(() => {
  if (window.__cvInit) return; window.__cvInit = true;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const drawer = () => $('[data-cv-drawer]');
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const sized = (u, w) => (u ? u + (u.includes('?') ? '&' : '?') + 'width=' + w : '');
  const num = (c, d, t, s = '.') => { let [i, f] = (c / 100).toFixed(d).split('.'); i = i.replace(/\B(?=(\d{3})+(?!\d))/g, t); return f ? i + s + f : i; };
  const money = c => {
    const f = (drawer() && drawer().dataset.moneyFormat) || '${{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) =>
      k === 'amount_no_decimals' ? num(c, 0, ',') :
      k === 'amount_with_comma_separator' ? num(c, 2, '.', ',') :
      k === 'amount_no_decimals_with_comma_separator' ? num(c, 0, '.') : num(c, 2, ','));
  };
  const json = { 'Content-Type': 'application/json', Accept: 'application/json' };
  let isOpen = false, count = 0;

  const setBar = () => { const b = $('[data-cv-bar]'); if (b) b.hidden = isOpen || count === 0; };
  function openCart() {
    const d = drawer(); if (!d) { location.href = root + 'cart'; return; }
    isOpen = true; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    $('[data-cv-overlay]').hidden = false; document.documentElement.style.overflow = 'hidden'; setBar();
  }
  function closeCart() {
    const d = drawer(); if (!d) return;
    isOpen = false; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    $('[data-cv-overlay]').hidden = true; document.documentElement.style.overflow = ''; setBar();
  }
  function render(cart) {
    count = cart.item_count;
    $$('[data-cv-cart-count]').forEach(n => (n.textContent = count));
    $$('[data-cv-total]').forEach(n => (n.textContent = money(cart.total_price)));
    document.body.classList.toggle('cv-has-items', count > 0);
    const d = drawer();
    if (d) {
      $('[data-cv-empty]', d).hidden = count > 0;
      $('[data-cv-footer]', d).hidden = count === 0;
      const pack = d.dataset.packLabel || 'Paquete';
      $('[data-cv-items]', d).innerHTML = cart.items.map(i => `
        <div class="cv-item">
          <a href="${esc(i.url)}" class="cv-item__img">${i.image ? `<img src="${esc(sized(i.image, 160))}" alt="" loading="lazy">` : ''}</a>
          <div class="cv-item__info">
            <b>${esc(i.product_title)}</b>
            ${i.variant_title ? `<span>${esc(pack)} ${esc(i.variant_title)}</span>` : ''}
            <div class="cv-qty">
              <button type="button" data-cv-qty="${i.quantity - 1}" data-key="${esc(i.key)}" aria-label="Quitar uno">−</button>
              <span>${i.quantity}</span>
              <button type="button" data-cv-qty="${i.quantity + 1}" data-key="${esc(i.key)}" aria-label="Agregar uno">+</button>
              <button type="button" class="cv-item__rm" data-cv-qty="0" data-key="${esc(i.key)}">Quitar</button>
            </div>
          </div>
          <b class="cv-cond cv-item__price">${money(i.final_line_price)}</b>
        </div>`).join('');
    }
    setBar();
  }
  const refresh = () => fetch(root + 'cart.js', { headers: json }).then(r => r.json()).then(render).catch(() => {});
  async function change(id, quantity) {
    const d = drawer(); d && d.classList.add('is-busy');
    try { const r = await fetch(root + 'cart/change.js', { method: 'POST', headers: json, body: JSON.stringify({ id, quantity }) }); render(await r.json()); }
    finally { d && d.classList.remove('is-busy'); }
  }

  document.addEventListener('click', e => {
    const t = e.target;
    const menuBtn = t.closest('[data-cv-menu-toggle]');
    if (menuBtn) {
      const m = $('[data-cv-menu]'); const open = m.hidden;
      m.hidden = !open; menuBtn.setAttribute('aria-expanded', open); menuBtn.textContent = open ? '×' : '≡';
      return;
    }
    if (t.closest('[data-cv-menu] a')) { const m = $('[data-cv-menu]'); m.hidden = true; const b = $('[data-cv-menu-toggle]'); if (b) { b.textContent = '≡'; b.setAttribute('aria-expanded', false); } }
    if (t.closest('[data-cv-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-cv-cart-close]')) { e.preventDefault(); closeCart(); return; }
    const q = t.closest('[data-cv-qty]');
    if (q) { change(q.dataset.key, Math.max(0, +q.dataset.cvQty)); return; }
    const v = t.closest('[data-cv-video]');
    if (v && v.dataset.embed) {
      e.preventDefault();
      v.innerHTML = `<iframe src="${esc(v.dataset.embed)}" class="cv-fill" style="border:0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
      v.removeAttribute('data-cv-video'); v.removeAttribute('href');
    }
  });

  document.addEventListener('change', e => {
    const r = e.target.closest('[data-cv-pack]'); if (!r) return;
    const price = $('[data-cv-add-price]', r.form); if (price) price.textContent = r.dataset.price;
    const box = $('[data-cv-img]', r.closest('.cv-product'));
    if (box && r.dataset.img) {
      let im = $('img', box);
      if (!im) { box.innerHTML = ''; im = document.createElement('img'); im.className = 'cv-fill'; im.alt = ''; box.appendChild(im); }
      im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.src = r.dataset.img;
    }
  });

  document.addEventListener('submit', async e => {
    const f = e.target.closest('[data-cv-product-form]'); if (!f) return;
    e.preventDefault();
    const btn = $('[type="submit"]', f); btn.disabled = true;
    try {
      const id = +new FormData(f).get('id');
      const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id, quantity: 1 }] }) });
      if (!r.ok) { const j = await r.json().catch(() => ({})); alert(j.description || 'No se pudo agregar al carrito.'); return; }
      await refresh(); openCart();
    } finally { btn.disabled = false; }
  });

  document.addEventListener('keydown', e => { if (e.key === 'Escape' && isOpen) closeCart(); });
  document.addEventListener('shopify:section:load', refresh);
  refresh();
})();
